import * as React from 'react'

import { Button, ButtonProps } from '../button'
import { ButtonGroup } from '../button-group'
import { Icon } from '../icon'
import { Dropdown } from './dropdown'
import { useDropdownState } from './hooks'

interface MoreButtonDropdownProps extends ButtonProps {
  /**
   * Children of the button
   */
  label?: React.ReactNode

  /**
   * Additional handler when user clicks on the button
   */
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void

  /**
   * Accessibility label for the dropdown component
   */
  'aria-label': string
}

export function MoreButtonDropdown({
  label,
  children,
  onClick,
  'aria-label': ariaLabel,
  ...props
}: React.PropsWithChildren<MoreButtonDropdownProps>) {
  const state = useDropdownState({ placement: 'bottom-end' })

  return (
    <ButtonGroup hasDivider={false} hasBorder={false}>
      <Button className="focus:z-10" theme="light" onClick={onClick} {...props}>
        {label}
      </Button>
      <Dropdown
        state={state}
        aria-label={ariaLabel}
        label={
          <Button
            {...props}
            rightContent={undefined}
            className="rounded-l-none"
            appearance="square"
            type="button"
            size={props.size}
          >
            <Icon name="more" />
          </Button>
        }
      >
        {children}
      </Dropdown>
    </ButtonGroup>
  )
}
